(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-product__buy-buttons"] && !Shopify.designMode) return;
  try {
    function updateQuantityButtons() {
    const quantityWrappers = document.querySelectorAll('.quantity');

    quantityWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('.quantity__input');
      const btnPlus = wrapper.querySelector('.quantity__button[name="plus"]');
      const btnMinus = wrapper.querySelector('.quantity__button[name="minus"]');

      if (!input || !btnPlus) return;

      let currentValue = parseInt(input.value, 10) || 0;
      const maxInventory = parseInt(btnPlus.dataset.inventoryQuantity, 10) || Infinity;
      const min = parseInt(input.min, 10) || 1;

      // Se l'utente inserisce manualmente un valore maggiore del massimo, lo corregge
      if (currentValue > maxInventory) {
        currentValue = maxInventory;
        input.value = maxInventory;
      }

      // Blocca il + se raggiunto il massimo
      btnPlus.disabled = currentValue >= maxInventory;

      // Blocca il - se raggiunto il minimo
      if (btnMinus) btnMinus.disabled = currentValue <= min;
    });
  }

  // Aggiorna subito al caricamento
  updateQuantityButtons();

  // Aggiorna ogni volta che cambia l'input
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', updateQuantityButtons);
  });
  } catch(e) { console.error(e); }
})();

})();
